var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 68,
    viewBox: "0 0 72 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#334F93",
    d: "M64.702 28.094a2.854 2.854 0 0 0-2.854 2.854v2.874c-.004 7.498-2.928 14.545-8.233 19.844-5.301 5.295-12.345 8.21-19.837 8.21h-.016C18.284 61.867 5.699 49.268 5.708 33.79c.004-7.498 2.928-14.545 8.233-19.844 5.3-5.295 12.345-8.21 19.836-8.21h.017c3.956.002 7.795.82 11.408 2.43a2.854 2.854 0 1 0 2.323-5.213A33.564 33.564 0 0 0 33.797.028h-.02c-9.014 0-17.492 3.51-23.87 9.88C3.524 16.284.005 24.764 0 33.787c-.005 9.022 3.503 17.506 9.88 23.89 6.376 6.383 14.856 9.902 23.878 9.907h.02c9.015 0 17.492-3.509 23.87-9.88 6.384-6.376 9.902-14.856 9.907-23.88v-2.876a2.854 2.854 0 0 0-2.853-2.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED8808",
    d: "M69.812 3.974a2.854 2.854 0 0 0-4.036 0L33.778 35.973l-7.26-7.26a2.854 2.854 0 1 0-4.035 4.036l9.277 9.277a2.845 2.845 0 0 0 2.018.836c.73 0 1.46-.278 2.018-.836L69.812 8.01a2.854 2.854 0 0 0 0-4.036z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.3c21025a83d3f9294171fdb60d7eb1cd.svg";
export { ForwardRef as ReactComponent };